import TEXTS from '../../../locale/texts';
import { makeMsisdnBeautiful } from '../../../Utils';
import { Button, Icon } from 'antd';
import React from 'react';

const showMsisdnsColumns = function() {
  const { lang } = this.props;
  const { currentPage, pageSize } = this.state;
  return [{
    title: '#',
    width: 40,
    key: 'index',
    render: (text, record, index) => {
      const indexZeroBase = currentPage === 1
        ? index
        : (index + (pageSize * (currentPage - 1)));
      return indexZeroBase + 1;
    }},
    {
      title: TEXTS.contactPhoneLabel[lang],
      width: 200,
      dataIndex: 'msisdn',
      render: (msisdn) => makeMsisdnBeautiful(msisdn)
    },
    {
      title: TEXTS.dataParam1[lang],
      width: 200,
      dataIndex: 'param1',
      render: (text) =>
        (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam2[lang],
      width: 200,
      dataIndex: 'param2',
      render: (text) =>
        (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam3[lang],
      width: 200,
      dataIndex: 'param3',
      render: (text) =>
        (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam4[lang],
      width: 200,
      dataIndex: 'param4',
      render: (text) =>
        (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      key: 'button',
      render: (text, { msisdn, lang }) => {
        return(
          <Button
            title={TEXTS.btnRemoveMsisdnFromCampaign[lang]}
            style={{padding: '0 6px'}}
            onClick={(e) => {
              this.removeMsisdn(msisdn);
              // to disable focused state
              e.target.blur();
            }}
          >
            <Icon
              type="delete"
              style={{position: 'relative', top: -3, fontSize: 16}}
            />
          </Button>
        );
      }
    }
  ];
};

export { showMsisdnsColumns };
